module.exports = __webpack_public_path__ + "img/Credit-card-background-shallow-DOF.f494e38e.png";